import { Box, CardContent, CardHeader, Stack, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import React, { useEffect, useRef, useState } from 'react';
import { constants } from '../../constants';
import useWebContext from '../../hooks/useWebContext';
import { MyMDropDownList } from '../../ui-elements/MyMDropDownList';
import { MyMImage } from '../../ui-elements/MyMImage';
import { MyMLabel } from '../../ui-elements/MyMLabel';
import { MyMBlackLink, MyMLink } from '../../ui-elements/MyMLink';
import { MyMProgressPartially } from '../../ui-elements/MyMProgressPartially';
import BoxFileRequestMenu from "../../ui-parts/BoxFileRequestMenu";
import { FileMappingIcon } from '../../ui-parts/FileMappingIcon';
import { KeywordLabel } from '../../ui-parts/KeywordLabel';
import { OutlinedCustomCard } from '../../ui-parts/OutlinedCustomCard';
import { Pager } from '../../ui-parts/Pager';
import { GridTooltipCell } from '../../ui-parts/TooltipLabel';
import { utility } from '../../utility';
import { mediaQuery, useMediaQuery } from '../../hooks/useMediaQuery';
import { FilterMenu } from '../../ui-parts/FilterMenu';
import { IconButton } from '@mui/material';
import PendingIcon from '@mui/icons-material/Pending';
import Popover from '@mui/material/Popover';
import Grid from '@mui/material/Grid';

// MyMine Version2.1 Advanced Search機能追加
const SearchResultListViewSearchResultAdvCard = (props) => {
  const {
    screenId,
    pageNumber,
    setPageNumber,
    searchResult,
    onSortByChange,
    onClickPreview,
    controlSettings,
    messageList,
    sortByDDL,
    keyword,
    selectedSortBy,
    setIsLoading,
    isListLoading,
    apiRequest,
    metadataList,
    setApliableFilterList,
    checkedList,
    setCheckedList
    // 2026.2.25 タブレット表示時対応 Add Start
    , ellipsisNumberMobile,
    ellipsisNumberPC
    // 2026.2.25 タブレット表示時対応 Add End
  } = props;

  const searchResultImageScreenId = 'MyM402';
  const searchResultImageContext = useWebContext(searchResultImageScreenId);
  const theme = useTheme();
  const tableBodyRef = useRef(null);

  const isPc = useMediaQuery(mediaQuery.pc);
  const [isOpenFilterMenu, setIsOpenFilterMenu] = useState(false);
  const openFilterMenu = () => setIsOpenFilterMenu(true);
  const closeFilterMenu = () => setIsOpenFilterMenu(false);
  // 2026.2.25 タブレット表示時対応 Add Start
  const isMobile = useMediaQuery('(max-width:600px)');
  const ellipsisNumber = isMobile ? ellipsisNumberMobile : ellipsisNumberPC;
  // 2026.2.25 タブレット表示時対応 Add End

  // 一覧更新時はスクロール位置をトップに戻す
  useEffect(() => {
    setTimeout(() => {
      if (tableBodyRef.current)
        tableBodyRef.current.scrollTop = 0;
    }, 0);
  }, [searchResult.ItemList])

  const navigateNewsPage = (newsId, url, newsType) => {
    if (newsType === constants.NewsType.InternalNews) {
      // InternalNews
      window.open(`${process.env.PUBLIC_URL}/MyM102/MyM501/MyM502/${newsId}`, '_blank');
      return;
    } else {
      // GlobalSiteNews
      apiRequest.requestJson('api/news/external-link-transition?newsId=' + newsId, 'GET', null, null, null);
      window.open(url, '_blank');
    }
  }

  /**
   * お気に入りコールバック処理
   * @param {number} favoriteFileId お気に入りファイルID
   */
  const callbackFavorite = (favoriteFileId) => {
    const favoriteFile = searchResult.ItemList.find(x => x.DataId === favoriteFileId);
    // お気に入り情報を更新
    favoriteFile.IsFavorite = !favoriteFile.IsFavorite;
  }

  const styles = {
    fontSize: '0.95rem',
    width: '50%'
  };
  const [popoverState, setPopoverState] = useState({});

  const handleClick = (event, rowDataId) => {
    setPopoverState({
      ...popoverState,
      [rowDataId]: {
        open: true,
        anchorEl: event.currentTarget
      }
    });
  };

  const handleClose = (rowDataId) => {
    setPopoverState({
      ...popoverState,
      [rowDataId]: {
        open: false,
        anchorEl: null
      }
    });
  };

  return (
    <OutlinedCustomCard>
      <CardHeader
        sx={{ display: 'flex', background: theme.palette.background.secondary, height: '65px' }}
        action={
          <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end' }}>
            <MyMDropDownList
              autoWidth
              value={selectedSortBy}
              onChange={(e) => { onSortByChange(e) }}
              options={sortByDDL.map((data) => {
                return {
                  value: data.value,
                  text: data.text
                }
              })}
              sx={{ color: 'white', width: isPc ? '300px' : '250px' }}
            />
            {!isPc &&
              <Box sx={{ display: 'flex', alignItems: 'center', marginRight: '10px' }}>
                <FilterMenu
                  isOpenFilterMenu={isOpenFilterMenu}
                  openFilterMenu={openFilterMenu}
                  closeFilterMenu={closeFilterMenu}
                  content={metadataList}
                  controlSettings={controlSettings}
                  setApliableFilterList={setApliableFilterList}
                  checkedList={checkedList}
                  setCheckedList={setCheckedList}
                />
              </Box>
            }
          </Box>
        }
      />
      <CardContent sx={{ height: 585, position: isPc && 'relative', overflowY: 'hidden', paddingTop: '5px', paddingLeft: isPc ? '40px' : '20px', paddingRight: isPc ? '40px' : '20px' }}>
        {isListLoading && <MyMProgressPartially />}
        <MyMLabel>{controlSettings.LabelList.lblKeywordTitle} "<MyMLabel component='span' sx={{ color: 'red' }}>{keyword}</MyMLabel>"</MyMLabel>
        {searchResult.ItemList.length === 0
          ? <MyMLabel className='d-flex justify-content-center'>{messageList.MyM_MSG_I_0023}</MyMLabel>
          :
          <>
            <Box sx={{
              height: { xs: '80%', sm: '89%' },
              '.MuiDataGrid-root': { border: 'none', marginBottom: 3 },
            }}>
              <TableContainer className='h-100 overflow-x-visible'>
                <Table className='h-100 d-block'>
                  <TableBody
                    ref={tableBodyRef}
                    className='h-100 d-block overflow-auto'
                    sx={{ maxHeight: 'calc(100% - 10px)', width: 'auto' }}>
                    {searchResult.ItemList.map((data) => {

                      const searchResultImageControlSettings = searchResultImageContext.controlSettings;
                      let title = '';
                      let noImageFilePath = '';
                      let imageFilePath = '';
                      switch (data.DataType) {
                        case constants.DataType.Box:
                          title = data.NameDisp;
                          noImageFilePath = `${process.env.PUBLIC_URL}/${searchResultImageScreenId}/${searchResultImageControlSettings.ImageList.imgNoThumbnailImage}`;
                          imageFilePath = data.ThumbnailFilePath ? `api/page/file?fileName=${data.ThumbnailFilePath}` : noImageFilePath;
                          break;
                        case constants.DataType.News:
                          title = data.Title;
                          noImageFilePath = `${process.env.PUBLIC_URL}/${searchResultImageScreenId}/${searchResultImageControlSettings.ImageList.imgNewsNoThumbnailImage}`;
                          imageFilePath = data.ThumbnailFilePath ? `api/news/image?newsId=${data.DataId}&fileName=${data.ThumbnailFilePath}` : `${process.env.PUBLIC_URL}/${searchResultImageScreenId}/${searchResultImageControlSettings.ImageList.imgNewsNoThumbnailImage}`;
                          break;
                        case constants.DataType.Contents:
                          title = controlSettings.LabelList[`lblDocument_${data.DataId}`];
                          noImageFilePath = `${process.env.PUBLIC_URL}/${searchResultImageScreenId}/${searchResultImageControlSettings.ImageList.imgContentsNoThumbnailImage}`;
                          imageFilePath = searchResultImageControlSettings.ImageList[`imgContentsThumbnail_${data.DataId}`] ? `${process.env.PUBLIC_URL}/${searchResultImageScreenId}/${searchResultImageControlSettings.ImageList[`imgContentsThumbnail_${data.DataId}`]}` : noImageFilePath;
                          break;
                        default:
                          break;
                      }


                      return (
                        <React.Fragment key={data.DataId}>
                          {
                            isPc ?
                              <>
                                <TableRow sx={{ display: { sx: 'block', sm: 'flex' }, 'td': { borderBottom: 'none', p: 1, display: 'flex', alignItems: 'center' } }}>
                                  <TableCell className='z-0' width='300px' sx={{ display: 'block', '> div': { width: '100%' }, 'img': { marginRight: '5px' } }}>
                                    <GridTooltipCell toolTipValue={title} width={'20%'}>
                                      {
                                        data.DataType === constants.DataType.Box ?
                                          <MyMBlackLink component='a' className='text-truncate' sx={{ cursor: 'pointer' }} notUseLabel={true} onClick={(e) => { onClickPreview(e, data.DataId) }}>
                                            <Box className='d-inline-block'>
                                              {/* Icon */}
                                              <FileMappingIcon screenId={screenId} extension={data.Extension} width="35px" height="35px" />
                                            </Box>
                                            {/* Title(File Name, Contents Name) */}
                                            <KeywordLabel keyword={keyword} value={title} fontSize={styles.fontSize} />
                                          </MyMBlackLink>
                                          :
                                          <MyMBlackLink component='a' className='text-truncate' sx={{ cursor: 'pointer' }} notUseLabel={true}
                                            onClick={() => data.DataType === constants.DataType.News ?
                                              navigateNewsPage(data.DataId, data.Url, data.NewsType) :
                                              window.open(controlSettings.UrlList[`urlContents_${data.DataId}`], '_blank')}
                                          >
                                            <Box className='d-inline-block'>
                                              <MyMImage
                                                screenId={screenId}
                                                filePath={data.DataType === constants.DataType.News ? controlSettings.ImageList.imgNewsIcon : controlSettings.ImageList.imgContentsIcon}
                                                width="35px"
                                                height="35px"
                                              />
                                              {/* Title(File Name, Contents Name) */}
                                              <KeywordLabel keyword={keyword} value={title} fontSize={styles.fontSize} />
                                            </Box>
                                          </MyMBlackLink>
                                      }
                                    </GridTooltipCell>
                                  </TableCell>
                                  <TableCell className='z-0' sx={{ width: { sm: 200, lg: 500 }, display: 'block !important' }}>
                                    { /* Description */}
                                    <GridTooltipCell
                                      toolTipValue={data.Description}
                                      width={'40%'}
                                    >{data.DataType !== constants.DataType.Contents ? data.Description : controlSettings.LabelList[`lblDescription_${data.DataId}`]}
                                    </GridTooltipCell>
                                  </TableCell>
                                  <TableCell width='150px'>
                                    { /* ファイルサイズ */}
                                    <MyMLabel>{controlSettings.LabelList.lblFileSizeHeader} : {data.FileSize != null ? `${utility.convertFileSize(data.FileSize, constants.FileSize.MB)?.toFixed(1)}${controlSettings.LabelList.lblFileSizeUnit}` : '-'}</MyMLabel>
                                  </TableCell>
                                  <TableCell sx={{ width: { xs: '200px', lg: '150px', xl: '200px' } }}>
                                    { /* 更新日 */}
                                    <MyMLabel>{data.DataType !== constants.DataType.Contents ? utility.formatDateTime(data.UploadDate, 'd MMMM yyyy') : '-'}</MyMLabel>
                                  </TableCell>
                                  <TableCell>
                                    { /* ファイル操作メニュー・リンク */}
                                    <Box sx={{ textAlign: 'center' }}>
                                      {
                                        data.DataType === constants.DataType.Box ?
                                          <BoxFileRequestMenu
                                            screenId={screenId}
                                            fileId={data.DataId}
                                            setIsLoading={setIsLoading}
                                            isFavorite={data.IsFavorite}
                                            callbackFavorite={callbackFavorite}
                                            canShareContents={true}
                                            listViewFlg={true}
                                          /> :
                                          <MyMLink
                                            onClick={() => data.DataType === constants.DataType.News ?
                                              navigateNewsPage(data.DataId, data.Url, data.NewsType) :
                                              window.open(controlSettings.UrlList[`urlContents_${data.DataId}`], '_blank')}
                                          >
                                            {data.DataType === constants.DataType.News ?
                                              controlSettings.LabelList.lnkGoToNews :
                                              controlSettings.LabelList.lnkGoToContent}
                                          </MyMLink>
                                      }
                                    </Box>
                                  </TableCell>
                                </TableRow>
                                <TableRow className='d-flex'>
                                  <TableCell colSpan={5} width='100%' sx={{ p: 1 }}>
                                    <Stack direction='row' className='w-100'>
                                      { /* サムネイル画像 */}
                                      <Box sx={{ textAlign: 'center', position: 'relative', height: '80px' }}>
                                        <img
                                          src={imageFilePath}
                                          className='d-inline'
                                          alt=''
                                          style={{
                                            width: '130px',
                                            maxHeight: '80px',
                                            objectFit: 'contain',
                                            ...data.DataType === constants.DataType.Box ? { cursor: 'pointer' } : {}
                                          }}
                                          onError={({ currentTarget }) => {
                                            currentTarget.onerror = null;
                                            currentTarget.src = noImageFilePath;
                                          }}
                                          onClick={(e) => { data.DataType === constants.DataType.Box && onClickPreview(e, data.DataId) }}
                                        />
                                      </Box>
                                      {/* Snippets */}
                                      <Box className='ms-2' sx={{ overflowWrap: 'anywhere', color: '#808080ad', 'em': { color: 'red', fontStyle: 'normal' } }}>
                                        <KeywordLabel multiline={true} keyword={keyword} value={data.Snippets} fontSize={styles.fontSize} isDangerouslySetInnerHTML={data.DataType === constants.DataType.Box && data.Snippets.match(/<em>.*<\/em>/g) !== null} />
                                      </Box>
                                    </Stack>
                                  </TableCell>
                                </TableRow>
                              </>
                              :
                              <>
                                <TableRow>
                                  <TableCell>
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                      {data.DataType === constants.DataType.Box ?
                                        <>
                                          <MyMBlackLink
                                            component="a"
                                            className="text-truncate"
                                            sx={{ cursor: 'pointer' }}
                                            notUseLabel={true}
                                            onClick={(e) => { onClickPreview(e, data.DataId); }}
                                          >
                                            <Box className="d-inline-block pe-2">
                                              <FileMappingIcon screenId={screenId} extension={data.Extension} width="45px" height="45px" />
                                            </Box>
                                          </MyMBlackLink>
                                          <Box sx={{ display: 'inline-block', verticalAlign: 'top' }}>
                                            <MyMBlackLink
                                              component="a"
                                              className="text-truncate"
                                              sx={{ cursor: 'pointer' }}
                                              notUseLabel={true}
                                              onClick={(e) => { onClickPreview(e, data.DataId); }}
                                            >
                                              {/* 2026.2.25 タブレット表示時対応 Modify Start */}
                                              <KeywordLabel keyword={keyword} value={utility.convertEllipsisFormat(data.NameDisp, ellipsisNumber)} fontSize={styles.fontSize} />
                                              {/* 2026.2.25 タブレット表示時対応 Modify End */}
                                            </MyMBlackLink>
                                            <Box sx={{ display: 'flex', marginTop: 0.5 }}>
                                              <Box sx={{ marginRight: 1, fontSize: styles.mobileFontSize }}>
                                                {data.FileSize != null
                                                  ? `${utility.convertFileSize(data.FileSize, constants.FileSize.MB)?.toFixed(1)}${controlSettings.LabelList.lblFileSizeUnit}`
                                                  : '-'}
                                              </Box>
                                              <Box sx={{ fontSize: styles.mobileFontSize }}>
                                                {data.DataType !== constants.DataType.Contents ? utility.formatDateTime(data.UploadDate, 'd MMMM yyyy') : '-'}
                                              </Box>
                                            </Box>
                                          </Box>

                                        </>
                                        :
                                        <>

                                          <Box className="d-inline-block pe-2">
                                            <MyMImage
                                              screenId={screenId}
                                              filePath={data.DataType === constants.DataType.News ? controlSettings.ImageList.imgNewsIcon : controlSettings.ImageList.imgContentsIcon}
                                              width="45px"
                                              height="50px"
                                            />
                                          </Box>
                                          <Box sx={{ display: 'inline-block', verticalAlign: 'top' }}>
                                            {/* 2026.2.25 タブレット表示時対応 Modify Start */}
                                            <KeywordLabel
                                              keyword={keyword}
                                              value={data.DataType === constants.DataType.News ? utility.convertEllipsisFormat(data.Title, ellipsisNumber) : utility.convertEllipsisFormat(controlSettings.LabelList[`lblDocument_${data.DataId}`], ellipsisNumber)}
                                              fontSize={styles.fontSize}
                                            />
                                            {/* 2026.2.25 タブレット表示時対応 Modify End */}
                                            <Box sx={{ display: 'flex', marginTop: 0.5 }}>
                                              <Box sx={{ marginTop: 1, fontSize: styles.mobileFontSize }}>
                                                {data.FileSize != null
                                                  ? `${utility.convertFileSize(data.FileSize, constants.FileSize.MB)?.toFixed(1)}${controlSettings.LabelList.lblFileSizeUnit}`
                                                  : '-'}
                                              </Box>
                                              <Box sx={{ fontSize: styles.mobileFontSize }}>
                                                {data.DataType !== constants.DataType.Contents ? utility.formatDateTime(data.UploadDate, 'd MMMM yyyy') : '-'}
                                              </Box>
                                            </Box>
                                          </Box>

                                        </>
                                      }
                                      <Box sx={{ display: 'flex', justifyContent: 'flex-end', flexGrow: 1 }}>
                                        <IconButton onClick={(e) => handleClick(e, data.DataId)}>
                                          <PendingIcon />
                                        </IconButton>
                                      </Box>
                                      <Popover
                                        open={popoverState[data.DataId]?.open || false}
                                        anchorEl={popoverState[data.DataId]?.anchorEl || null}
                                        onClose={() => handleClose(data.DataId)}
                                        anchorOrigin={{
                                          vertical: 'bottom',
                                          horizontal: 'left',
                                        }}
                                        transformOrigin={{
                                          vertical: 'top',
                                          horizontal: 'left',
                                        }}
                                      >
                                        <Box sx={{ padding: '16px' }}>
                                          <Box sx={{ textAlign: 'center' }}>

                                            {data.DataType === constants.DataType.Box ? (
                                              <BoxFileRequestMenu
                                                screenId={screenId}
                                                fileId={data.DataId}
                                                setIsLoading={setIsLoading}
                                                isFavorite={data.IsFavorite}
                                                callbackFavorite={callbackFavorite}
                                                canShareContents={true}
                                                listViewFlg={true}
                                              />
                                            ) : (
                                              <MyMLink
                                                onClick={() => data.DataType === constants.DataType.News
                                                  ? navigateNewsPage(data.DataId, data.Url, data.NewsType)
                                                  : window.open(controlSettings.UrlList[`urlContents_${data.DataId}`], '_blank')}
                                              >
                                                {data.DataType === constants.DataType.News
                                                  ? controlSettings.LabelList.lnkGoToNews
                                                  : controlSettings.LabelList.lnkGoToContent}
                                              </MyMLink>
                                            )}
                                          </Box>
                                        </Box>
                                      </Popover>
                                    </Box>
                                    <Grid className='w-100' sx={{ marginTop: 1, }}>
                                      {/* サムネイル画像 */}
                                      <Grid alignItems="start" sx={{ float: 'left' }}>
                                        <img
                                          src={imageFilePath}
                                          className='d-inline'
                                          alt=''
                                          style={{
                                            width: '130px',
                                            maxHeight: '80px',
                                            objectFit: 'contain',
                                            margin: 5,
                                            cursor: data.DataType === constants.DataType.Box ? 'pointer' : 'default'
                                          }}
                                          onError={({ currentTarget }) => {
                                            currentTarget.onerror = null;
                                            currentTarget.src = noImageFilePath;
                                          }}
                                          onClick={(e) => { data.DataType === constants.DataType.Box && onClickPreview(e, data.DataId) }}
                                        />
                                      </Grid>
                                      {/* Snippets */}
                                      <Grid item className='ms-2' sx={{ color: '#808080ad', 'em': { color: 'red', fontStyle: 'normal' } }}>
                                        <KeywordLabel
                                          multiline={true}
                                          keyword={keyword}
                                          value={data.Snippets}
                                          fontSize={styles.fontSize}
                                          isDangerouslySetInnerHTML={data.DataType === constants.DataType.Box && data.Snippets.match(/<em>.*<\/em>/g) !== null}
                                        />
                                      </Grid>
                                    </Grid>
                                  </TableCell>
                                </TableRow>
                              </>
                          }

                        </React.Fragment>
                      )
                    }
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
              <Pager
                resultListItem={searchResult}
                handleChangePage={(pageNum) => setPageNumber(pageNum)}
                labelList={controlSettings.LabelList}
                pageNumber={pageNumber}
              />
            </Box>
          </>
        }
      </CardContent>
    </OutlinedCustomCard>
  );
}
export default SearchResultListViewSearchResultAdvCard;